import React, { Component } from 'react';
import './AdminCreateLocations.css';
import iconpen from '../../../../image/iconpen.svg'

class AdminCreateLocations extends Component {
    
    render() {
        return (
            <div className="EditFAQ">
                <p className="col-md-6 mt-2 p-0 fontsize4 font-weight-bold ">Contact details</p>
                <hr />
                <div className="form-group row my-5">
                        <label htmlFor="staticEmail" className="col-sm-4 col-md-6 col-lg-3  col-form-label ">Location name</label>
                        <div className="col-lg-4 col-sm-6 ">
                        <input type="text"  className="form-control badge-pill" id="staticEmail"  placeholder="Cairo"/>
                        </div>
                </div>
                <div className="text-center d-flex justify-content-around  flex-wrap my-3 col-lg-8">
                    <button className="btn badge-pill p-2 pl-1 px-3  m-1 border shadow bg-white " ><img className="mr-1" src={iconpen} alt="pen" />SAVE CHANGES  </button>
                    <button className="btn badge-pill p-2 pl-1 px-4  m-1 border shadow bg-white" >CANCEL</button>
                    </div>
            </div>

        )
    }
}
export default AdminCreateLocations;